// Simple toast notification — replaces alert() for iOS App Store compliance
let toastContainer: HTMLDivElement | null = null;
let toastTimeout: number | null = null;

function getContainer(): HTMLDivElement {
  if (toastContainer) return toastContainer;
  toastContainer = document.createElement('div');
  toastContainer.id = 'zeal-toast-container';
  toastContainer.style.cssText = 'position:fixed;top:env(safe-area-inset-top,16px);left:50%;transform:translateX(-50%);z-index:99999;display:flex;flex-direction:column;gap:8px;pointer-events:none;max-width:90vw;';
  document.body.appendChild(toastContainer);
  return toastContainer;
}

export function showToast(message: string, type: 'success' | 'error' | 'info' = 'info', duration = 3000) {
  const container = getContainer();
  const el = document.createElement('div');
  const bg = type === 'error' ? 'rgba(231,76,60,0.95)' : type === 'success' ? 'rgba(46,204,113,0.95)' : 'rgba(201,168,76,0.95)';
  el.style.cssText = `padding:12px 20px;border-radius:10px;background:${bg};color:#fff;font-size:14px;font-family:'Inter',-apple-system,sans-serif;text-align:center;pointer-events:auto;opacity:0;transition:opacity 0.3s;box-shadow:0 4px 12px rgba(0,0,0,0.3);`;
  el.textContent = message;
  container.appendChild(el);
  requestAnimationFrame(() => { el.style.opacity = '1'; });
  setTimeout(() => {
    el.style.opacity = '0';
    setTimeout(() => { el.remove(); }, 300);
  }, duration);
}
